// Adds `.is-revealed` to `.fade-reveal` elements once they scroll into view.
export default function reveal() {
  const items = document.querySelectorAll('.fade-reveal')
  if (!items.length || !('IntersectionObserver' in window)) return

  document.documentElement.classList.add('reveal-ready')

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return
      entry.target.classList.add('is-revealed')
      observer.unobserve(entry.target)
    })
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' })

  items.forEach((el) => observer.observe(el))
}
